/**
 * CSS for hiding elements, while keeping the content available
 * to assistive technologies.
 *
 * @example
 * // style as object
 * const styles = {
 *   ...visuallyHidden(),
 * }
 *
 * // emotion usage
 * styled.div`
 *   ${visuallyHidden()}
 * `;
 */
export default function visuallyHidden() {
  return {
    position: 'absolute',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    padding: '0',
    border: '0'
  };
}